export default __webpack_public_path__ + "static/part1_4mb-820916427e88fee523a62ab328abcf9d.png";